import type { ListConfig } from "src/system/module.types.ts";
import type { ClientConfig } from "src/client-config/getClientConfig.ts";
import { getAllModulesIds } from "src/system/getAllModulesIds.ts";

type ReturnType = {
  config: ListConfig<any> | { (client: ClientConfig): ListConfig<any> };
};

export const fetchResourceListConfig = async ({
  resource,
  clientConfig,
}: {
  resource: string;
  clientConfig: ClientConfig;
}): Promise<ListConfig<any>> => {
  const modules: string[] = getAllModulesIds();
  const lists = import.meta.glob("../admin/modules/*/lists/*/list.tsx");

  for (let i = 0; i < modules.length; i++) {
    const moduleId = modules[i];
    const importPath = `../admin/modules/${moduleId}/lists/${resource}/list.tsx`;

    if (Object.keys(lists).includes(importPath)) {
      const listConfig = ((await lists[importPath]()) as ReturnType).config;
      return typeof listConfig === "function"
        ? listConfig(clientConfig)
        : listConfig;
    }
  }

  throw new Error(
    `fetchResourceListConfig is not implemented for [${resource}] id`,
  );
};
